import React, { useEffect, useState } from 'react'
import DashboardHeader from './DashboardHeader'
import DashboardSidebar from './DashboardSidebar'
import Backdrop from '../../components/common/Backdrop'
import Breadcrumbs from '../../components/common/Breadcrumbs'
import Loading from '../../shared/common/Loading'
import { useLocation } from 'react-router-dom'
import useUserWalkthrough from '../../hooks/useUserWalkthrough'

const DashboardMaster = ({ children }) => {
    useUserWalkthrough();
    const [toogleMiniSidebar, setToogleMiniSidebar] = useState(false);
    const [toogleResponsiveSidebar, setToogleResponsiveSidebar] = useState(false);
    const [logoutLoading, setLogoutLoading] = useState(false)
    const { pathname } = useLocation()

    useEffect(() => {
        // Make the main page scrollbar none (WebKit + Firefox) for dashboard pages.
        const root = document.documentElement
        const body = document.body

        const prevRootScrollbarWidth = root.style.scrollbarWidth
        const prevBodyScrollbarWidth = body.style.scrollbarWidth
        const hadRootClass = root.classList.contains('scroll-sm')
        const hadBodyClass = body.classList.contains('scroll-sm')

        root.style.scrollbarWidth = 'none'
        body.style.scrollbarWidth = 'none'
        root.classList.add('scroll-sm')
        body.classList.add('scroll-sm')

        return () => {
            root.style.scrollbarWidth = prevRootScrollbarWidth
            body.style.scrollbarWidth = prevBodyScrollbarWidth
            if (!hadRootClass) root.classList.remove('scroll-sm')
            if (!hadBodyClass) body.classList.remove('scroll-sm')
        }
    }, [])

    return (
        <div className={`dashboard-layout bg-backgroundV1 min-h-screen ${logoutLoading ? 'opacity-50 cursor-not-allowed pointer-events-none' : ''}`}>
            <a
                href="#main-content"
                className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:bg-white focus:text-slate-900 focus:px-4 focus:py-2 focus:rounded-sm focus:shadow-lg focus:outline focus:outline-2 focus:outline-slate-900"
            >
                Skip to main content
            </a>
            <DashboardHeader toogleResponsiveSidebar={toogleResponsiveSidebar} setToogleResponsiveSidebar={setToogleResponsiveSidebar} toogleMiniSidebar={toogleMiniSidebar} />
            <DashboardSidebar setToogleResponsiveSidebar={setToogleResponsiveSidebar} toogleResponsiveSidebar={toogleResponsiveSidebar} setToogleMiniSidebar={setToogleMiniSidebar} toogleMiniSidebar={toogleMiniSidebar} logoutLoading={logoutLoading} setLogoutLoading={setLogoutLoading} />
            <main id="main-content" tabIndex={-1} className={`dashboard-layout-main transition-all duration-300 ${toogleMiniSidebar ? "lg:ps-[80px]" : "lg:ps-[300px]"} pt-[56px] min-h-[inherit]`}>
                <div className="dashboard-pages-wrapper relative">
                    {!(pathname?.startsWith("/policies")) && <section className='p-2 md:px-5'>
                        <Breadcrumbs />
                    </section>}
                    {children}
                    {logoutLoading && <div className='absolute top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%]'><Loading /></div>}
                </div>
            </main>
            <Backdrop onClose={() => setToogleResponsiveSidebar(false)} show={toogleResponsiveSidebar} />
        </div>
    )
}

export default DashboardMaster 